import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

export const getRtgsBankTemplates = async (params = {}) => {
  const { data } = await apiClient.get("/rtgs-bank-templates", { params })
  return data
}

export const getRtgsBankTemplate = async id => {
  const { data } = await apiClient.get(`/rtgs-bank-templates/${id}`)
  return data
}

export const createRtgsBankTemplate = async formData => {
  const { data } = await apiClient.post("/rtgs-bank-templates", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return data
}

export const updateRtgsBankTemplate = async ({ id, data: formData }) => {
  formData.append("_method", "PATCH")
  const { data } = await apiClient.post(`/rtgs-bank-templates/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return data
}

export const deleteRtgsBankTemplate = async id => {
  const { data } = await apiClient.delete(`/rtgs-bank-templates/${id}`)
  return data
}

export const previewRtgsBankTemplate = async (id, { onStart, onEnd } = {}) => {
  await downloadAndOpenFile({
    url: `/rtgs-bank-templates/${id}/preview`,
    openInNewTab: true,
    onStart,
    onEnd,
  })
}

export const getRtgsBankTemplateFile = async id => {
  const { data } = await apiClient.get(`/rtgs-bank-templates/${id}/file`, {
    responseType: "arraybuffer",
  })
  return data
}
